const externalActions = {
  ipWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "ip"
    }
  },
  userWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "user"
    }
  },
  hashWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "hash"
    }
  }
};
export default externalActions;
